// Dynamischer "Nächster Start"-Termin: nächster Montag als konkretes Datum.
export function nextMondayLabel() {
  const d = new Date();
  const add = (8 - d.getDay()) % 7 || 7;
  d.setDate(d.getDate() + add);
  return `Montag, ${d.toLocaleDateString("de-DE", { day: "2-digit", month: "2-digit" })}`;
}

// "Jeden Montag" → "Montag, TT.MM." – alles andere bleibt unverändert.
export function formatNextStart(nextStart) {
  return /jeden\s+montag/i.test(nextStart || "") ? nextMondayLabel() : nextStart;
}
